import Image from "next/image";
import { useState } from "react";

interface IconProps {
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  priority?: boolean;
  loading?: "lazy" | "eager";
}

const Icon = ({
  src = "",
  alt = "",
  width = 32,
  height = 32,
  priority = false,
  loading = "lazy",
}: IconProps) => {
  const [imageError, setImageError] = useState(false);

  const handleError = () => {
    setImageError(true);
  };

  if (!src || imageError) {
    return null;
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      onError={handleError}
      priority={priority}
      loading={loading}
    />
  );
};

export default Icon;
